// extracted by mini-css-extract-plugin
module.exports = {"container":"cardList__container___1WzQE","card--item":"cardList__card--item___10cCf"};